import { render, staticRenderFns } from "./CSMeet_matchItem.vue?vue&type=template&id=5afa52fd&scoped=true"
import script from "./CSMeet_matchItem.vue?vue&type=script&lang=js"
export * from "./CSMeet_matchItem.vue?vue&type=script&lang=js"
import style0 from "./CSMeet_matchItem.vue?vue&type=style&index=0&id=5afa52fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa52fd",
  null
  
)

export default component.exports